import { tokens } from '@equinor/eds-tokens';

var elevation = tokens.elevation,
  background = tokens.colors.ui.background__default.rgba;
var paper = {
  background: background
};

export { elevation, paper };
